import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'large' | 'medium';
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  variant = 'primary',
  size = 'large',
  onClick,
  className = ''
}: CTAButtonProps) {
  const baseStyles = 'font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl';
  const variantStyles = {
    primary: 'bg-gradient-to-r from-rose-400 to-pink-500 text-white hover:from-rose-500 hover:to-pink-600',
    secondary: 'bg-white text-rose-600 border-2 border-rose-400 hover:bg-rose-50'
  };
  const sizeStyles = {
    large: 'px-12 py-5 text-lg',
    medium: 'px-8 py-4 text-base'
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} data-id="element-311">
      {children}
    </motion.button>;
}